// extracted by mini-css-extract-plugin
export default {"container":"WelcomeSlide_container__YNXzA","header":"WelcomeSlide_header__Zqu8t","text":"WelcomeSlide_text__lxEgj","image":"WelcomeSlide_image__lDHSX"};